import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

const BASE_DATE_PICKER_CONFIG: Partial<BsDatepickerConfig> = {
  containerClass: 'theme-blue',
  showTodayButton: true,
  showClearButton: true,
  clearPosition: 'left',
  showWeekNumbers: false,
};

export const DATE_PICKER_CONFIG = (dateInputFormat: string, isMonthMode = false): Partial<BsDatepickerConfig> => ({
  ...BASE_DATE_PICKER_CONFIG,
  dateInputFormat: dateInputFormat.toLocaleUpperCase(),
  minMode: isMonthMode ? 'month' : null,
});
